import React from 'react';
import styles from './index.module.scss';
import logo from '~/assets/images/header-logo.png';
import { useTranslation } from 'react-i18next';
import { NavLink, useHistory } from 'react-router-dom';

const TheHeader = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className={styles.container}>
      <img className={styles.logo} src={logo} alt="logo" onClick={() => history.push('/')} />
      <div className={styles.nav}>
        <NavLink to="/order-tracking" activeClassName={styles.active} className={styles.navLink}>
          {t('header.orderTracking')}
        </NavLink>
        <NavLink to="/warranty-lookup" activeClassName={styles.active} className={styles.navLink}>
          {t('header.warrantyLookup')}
        </NavLink>
      </div>
      <a className={styles.button} href="https://honganh.vn/lien-he" target="_blank" rel="noreferrer">
        {t('header.contact')}
      </a>
    </div>
  );
};

export default TheHeader;
